<template>
    <rd-card type="vertical">
        <rd-card-header>
            <rd-header :title="$t('dashboard.countsByDay.title')" margins="none" size="medium" />
        </rd-card-header>
        <rd-card-content>
            <dx-chart :data-source="instancesOverYear"
                      :size="{height: 100}"
                      :legend="{ visible: false }"
                      :loadingIndicator="{ enabled: true }"
                      :series="chartSettings">
            </dx-chart>
        </rd-card-content>
    </rd-card>
</template>

<script>
    // @ is an alias to /src
    import { mapState, mapActions } from 'vuex';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    import DxChart from 'devextreme-vue/chart';

    const name = "processesStores/pzzDashboardStores/indexStore";

    export default {
        name: 'pzzDashboardCountsByDay',
        created() {
            this.setItemsPerDay();
        },
        data() {
            return {
                chartSettings: [{
                    type: 'splinearea',
                    argumentField: 'CreatedDate',
                    valueField: 'CreatedCount'
                }],
            }
        },
        computed: {
            ...mapState(name, ['instancesOverYear'])
        },
        methods: {
            ...mapActions(name, ['setItemsPerDay'])
        },
        components: {
            DxChart
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
